import { apiToken, apiBasic, apiTokenNotDecode, apiGet } from "./requests";

/**
 * Auth / Login
 * Nota: mantenemos los mismos endpoints y el mismo tipo de request
 * que ya estabas usando para no romper backend.
 */

export const logIn = (data = null) => {
  const path = "login";
  // Importante: devuelve response axios completo (lo usas con response.data.data)
  return apiTokenNotDecode(data, path);
};

export const lockOperator = (data = {}) => apiBasic(data, "lock-operator");

export const validateLogIn = (data) => {
  const path = "validate";
  return apiBasic(data, path);
};

export const recoverPassword = (data = null) => {
  const path = "forgot-password";
  return apiBasic(data, path);
};

export const resetPassword = (data) => {
  const path = "reset-password";
  return apiToken(data, path);
};

export const checkPassword = (data) => {
  const path = "check-tpv-password";
  return apiTokenNotDecode(data, path);
};

/**
 * Point-of-sale configurations
 */

export const getPointsConfigurations = () => {
  const path = "get-point-of-sale-configurations";
  return apiGet(path);
};

export const setPointConfigurations = (data) => {
  const path = "select-point-of-sale-configuration";
  // explícito para evitar dudas: POST
  return apiBasic(data, path, "post");
};
